import { render, staticRenderFns } from "./PurchasesPaymentStatusBadge.vue?vue&type=template&id=5d7e144c&"
import script from "./PurchasesPaymentStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PurchasesPaymentStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports